module.exports = __webpack_public_path__ + "icon-128-visualisation-map.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/icon-128-visualisation-map.png
// module id = 630
// module chunks = 11